module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "court.38f4fd72.webp";